import { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ShowCircleIcon from '@components/ShowCircleIcon'
import { mq, px2rem, showNameToSlug } from '@utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const ShowsInfoArtwork = memo(({ className, showPlacement }) => {
  const getSectorBoothValues = ({ sector, hall, boothName }) => [
    ...(sector ? [sector.name] : []),
    ...(hall ? [hall.name] : []),
    ...(boothName ? [boothName] : [])
  ]

  const isShowPlacementVisible = showPlacement && showPlacement.show
  const isSectorInfoVisible =
    isShowPlacementVisible && showPlacement.show.status && showPlacement.show.status.toUpperCase() === 'ACTIVE'

  return isShowPlacementVisible ? (
    <div className={className}>
      <div className='show-tag'>
        <ShowCircleIcon show={showNameToSlug(showPlacement.show.name).replace('-', '')} />
        {showPlacement.show.name} {showPlacement.show.editionYear}
        {isSectorInfoVisible ? ` | ${getSectorBoothValues(showPlacement).join(' | ')}` : ''}
      </div>
    </div>
  ) : null
})
ShowsInfoArtwork.displayName = 'ShowsInfoArtwork'

ShowsInfoArtwork.propTypes = {
  className: PropTypes.string,
  showPlacement: PropTypes.object
}

export default styled(ShowsInfoArtwork)`
  &&& {
    display: flex;
    ${mq.lessThan('largestTablet')`
      flex-direction: column;
    `}

    .show-tag {
      font-size: ${tokens.fontSize[3].value};
      margin-right: ${px2rem(20)};
      padding: ${px2rem(4)} 0;
      ${mq.lessThan('largestTablet')`
        font-size: ${tokens.fontSize[1].value};
      `}

      .show-icon {
        margin-right: ${px2rem(10)};
      }
    }

    .last-show {
      font-size: ${tokens.fontSize[1].value};
      opacity: 0.5;
    }
  }
`
